import { InformationRequest } from '../../lib/types/models/information-request/information-request'
import { InformationRequestInput } from '../../lib/types/models/information-request/information-request-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createInformationRequest(data: InformationRequestInput) {
  return restApiClient
    .url(constructApiUrl(API.informationRequests.create.url, null))
    .post<InformationRequest, InformationRequestInput>(data)
}
